import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/new/AboutNivaran/AboutNivaran.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/new/DonationBlock/DonationBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/new/StoryCard/StoryCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhyNIvaran"] */ "/app/src/components/new/WhyNivaran/WhyNIvaran.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubscribeButton"] */ "/app/src/components/SubscribeButton.tsx");
